import { render, staticRenderFns } from "./ChoiceView.vue?vue&type=template&id=7d538d79&scoped=true"
import script from "./ChoiceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoiceView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChoiceView.vue?vue&type=style&index=0&id=7d538d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d538d79",
  null
  
)

export default component.exports